import type { HTMLAttributes } from 'react';

import './tag.css';

export type TagType = 'Verification' | 'tag' | 'Awards' | 'Chips';
export type TagIcon = 'left' | 'Right' | 'no';

type TagNativeProps = Omit<HTMLAttributes<HTMLSpanElement>, 'children' | 'style'>;

export interface TagProps extends TagNativeProps {
  type: TagType;
  icon: TagIcon;
  label: string;
  onRemove?: () => void;
}

const FIGMA_NODE: Record<TagType, Record<TagIcon, string>> = {
  Verification: {
    left: '49:22073',
    Right: '49:22081',
    no: '49:22242',
  },
  tag: {
    left: '51:22763',
    Right: '51:22779',
    no: '51:22787',
  },
  Awards: {
    left: '49:22085',
    Right: '49:22205',
    no: '49:22219',
  },
  Chips: {
    left: '49:22111',
    Right: '49:22135',
    no: '49:22230',
  },
};

const TYPE_CLASS: Record<TagType, string> = {
  Verification: 'verification',
  tag: 'tag',
  Awards: 'awards',
  Chips: 'chips',
};

const ICON_CLASS: Record<TagType, string> = {
  Verification: 'check',
  tag: 'check',
  Awards: 'award',
  Chips: 'remove',
};

export function Tag({ type, icon, label, className = '', onRemove, ...props }: TagProps) {
  const renderedIcon = type === 'Awards' && icon === 'Right' ? 'left' : icon;
  const classes = [
    'lovo-tag',
    `lovo-tag--${TYPE_CLASS[type]}`,
    `lovo-tag--icon-${icon.toLowerCase()}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const iconNode = icon !== 'no' && (
    onRemove ? (
      <button
        type="button"
        className={`lovo-tag__icon lovo-tag__icon--${ICON_CLASS[type]} lovo-tag__icon--button`}
        aria-label={`Удалить ${label}`}
        onClick={(event) => {
          event.stopPropagation();
          onRemove();
        }}
      />
    ) : (
      <span
        className={`lovo-tag__icon lovo-tag__icon--${ICON_CLASS[type]}`}
        aria-hidden="true"
      />
    )
  );

  return (
    <span
      {...props}
      className={classes}
      data-figma-node={FIGMA_NODE[type][icon]}
      data-figma-variant={`Type=${type}, Icon=${icon}`}
    >
      {renderedIcon === 'left' && iconNode}
      <span className="lovo-tag__label">{label}</span>
      {renderedIcon === 'Right' && iconNode}
    </span>
  );
}
